import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-resize-4",
  "use": "icon-si-glyph-arrow-resize-4-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-resize-4\" id=\"icon-si-glyph-arrow-resize-4\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>126</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#434343\">\n            <path d=\"M14.12,16.003 L16,14.122 L12.962,11.065 L15.018,9 L9,9 L9,15.047 L11.087,12.95 L14.12,16.003 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M7,0.969 L4.913,3.065 L1.88,0.013 L0,1.894 L3.038,4.95 L1.042,6.917 L7,6.917 L7,0.969 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-resize-4.svg
// module id = 6x4Q
// module chunks = 62